import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import ProductPerformanceTable from "../../../components/ui/product-performance-table"
import { computeProductPerformance } from "../../../utils/productPerformanceHelpers"

const ProductPerformanceSection = ({ orgId, onNavigateTab }) => {
  const navigate = useNavigate()
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    computeProductPerformance(orgId).then((rows) => {
      setProducts(rows)
      setLoading(false)
    })
  }, [orgId])

  if (loading) {
    return <div className="h-80 bg-muted rounded-lg animate-pulse mb-6" />
  }

  return (
    <div className="bg-card border border-border rounded-lg p-5 mb-6">
      <ProductPerformanceTable
        title="Product Performance"
        products={products}
        onViewProduct={(row) => row?.viewProductPath && navigate(row.viewProductPath)}
        onViewAnalytics={(row) => onNavigateTab?.(row?.analyticsTab)}
      />
    </div>
  )
}

export default ProductPerformanceSection